import { TopoConnection } from "../Topology/TopoConnection";
import { DeviceCategory } from "../Core/DeviceCategory";
import { DeviceNode } from "../Topology/DeviceNode";
import { TopoNode } from "../Topology/TopoNode";

export class AssociatedConnection extends TopoConnection
{
	public Category: DeviceCategory;
	public DeviceNode: DeviceNode;
	public get Node(): TopoNode {
		return this.DeviceNode;
	}

	constructor(deviceNode: DeviceNode, category: DeviceCategory) {
		super();
		this.DeviceNode = deviceNode;
		this.Category = category;
	}

	public get DisplayName(): string {
		var text = '';
						
		if (this.Category == DeviceCategory.WirelessAp)
			text = "Wireless Access Point";
		else if (this.Category == DeviceCategory.WirelessController)
			text = "Wireless Controller";
		else if (this.Category == DeviceCategory.IpPhoneManager)
			text = "IP Phone Manager";
		else if (this.Category == DeviceCategory.VirtualHost)
			text = "Virtual Host";
		else if (this.Category == DeviceCategory.VirtualServer)
			text = "Virtual Server";
		else if (this.Category == DeviceCategory.Virtual)
			text = "virtual Machine";
		else
			text = "Association";

		return text;

	}
}
